<template>
  <div class="main-wrap problem">
    <div class="problem-top">
      <el-button type="primary" @click="exportOpen" :loading="exportLoading" icon="iconfont icondaochu" class="h40 exportOpen" plain>{{ $lang('导出') }}</el-button>
      <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
      <div class="problem-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="waybillNoList">
            <base-input-tag
              style="width: 210px"
              v-model="searchParam.waybillNoList"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }} </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="problem-table">
      <JmsTable
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange">
        <template #waybillNo="scope">
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(scope)" style="cursor: pointer">{{ $lang('复制运单号') }}</div>
            <span @click="$router.push({path: '/expressTracking', query: {waybillId: scope.row.waybillNo}})" class="getExpressTracking" >{{ scope.row.waybillNo }}</span>
          </el-tooltip>
        </template>
        <template #menu="scope">
          <div>
            <el-button @click="rowView(scope.row)" type="text">{{ $lang('查看') }}</el-button>
          </div>
        </template>
      </JmsTable>
    </div>
    <Detail ref="detail" :rowData="rowData" />
    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
  </div>
</template>

<script>
import { commonFun } from '@utils/common'
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'
import { problemDesc, asyExportDesc, getDetailById } from '@/api/module/customer'
import Detail from './components/Detail'

export default {
  mixins: [mixin],
  components: {
    JmsTable,
    ExportDownloadDialog,
    Detail,
  },
  data () {
    return {
      COM_HTTP: {
        reqList: problemDesc,
        reqDetail: getDetailById,
      },
      searchParam: {
        date: commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0],
        endDate: commonFun.GetTodayDate()[1],
        waybillNoList: [], // 运单号
        // startDate: '2021-12-13 00:00:00',
        // endDate: '2022-01-13 23:59:59',
        // customerCode: 'J0086024163',
      },
      page: {
        // 分页配置
        current: 1,
        size: 500,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      exportLoading: false,
      moduleType: 'vip_problem_desc',
      dialogExportDownVisible: false, // 下载中心
      isRowDetailUrl: true,
    }
  },
  computed: {
    listOpt () {
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '运单号',
            prop: 'waybillNo',
            slot: true,
          },
          {
            label: '问题件一级类型',
            prop: 'probleTypeSubjectName',
          },
          {
            label: '问题件二级类型',
            prop: 'secondLevelTypeName',
          },
          {
            label: '问题件原因',
            prop: 'probleDescription',
          },
        ],
      }
    },
  },
  methods: {
    // 触发按钮查询
    searchChange (params) {
      const { waybillNoList, startDate, endDate } = this.searchParam
      console.log(startDate, endDate)
      const space = 30 * 24 * 3600 * 1000
      const startTime = new Date(startDate).getTime()
      const endTime = new Date(endDate).getTime()
      if ((endTime - startTime) > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于30天'))
        return
      }
      // 处理运单编号
      if (waybillNoList && waybillNoList.length !== 0) {
        if (waybillNoList.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      this.searchFun(1)
    },
    getParams () {
      return Object.assign({}, this.searchParam)
    },
    // 重置搜索
    resetSearch () {
      this.searchParam = {
        waybillNoList: [],
        date: commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0],
        endDate: commonFun.GetTodayDate()[1],
      }
      this.$refs.BaseInputTag1.clearFn()
    },
    // 选择日期
    selectDate () {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.startDate = start
        this.searchParam.endDate = end
      }
    },
    async rowView (row) {
      await this.viewFun(row, { waybillNo: row.waybillNo })
      this.rowData = Object.assign(this.rowData, this.handleData(row))
      this.$refs.detail.showDialog()
    },
    async exportOpen () {
      console.log(this.selectedRows, this.searchParam)
      const { startDate, endDate } = this.searchParam
      let params = this.searchParam
      if (this.selectedRows.length) {
        const waybillNoList = this.selectedRows.map(item => item.waybillNo)
        params = {
          startDate,
          endDate,
          waybillNoList,
        }
      }
      try {
        this.exportLoading = true
        const res = await asyExportDesc(params)
        this.exportLoading = false
        if (res && res.succ) {
          this.$message.success(this.$lang('导出成功，请到下载中心查看'))
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      } catch (error) {
        console.log(error)
        this.exportLoading = false
      }
    },
    /**
     * 复制
     * @param data
     */
    handleCopy(data) {
      const value = data.row.waybillNo
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success',
      })
      oInput.remove()
    },
  },
}
</script>

<style lang="scss">
.problem {
  .problem-top {
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
    .problem-topLeft {
      margin-top: 10px;
    }
  }
  .problem-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }
  .problem-table {
    padding: 12px 24px;
  }
  .problem-nav {
    //   margin: 9px 0;
    .problem-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      //   width: 124px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .problem-nav-item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>
